
import { useDispatch } from "react-redux";
import {
    setCredentials,
    selectCurrentUser,
} from "../../redux/reducers/authSlice";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { apiSlice } from "../../redux/api/apiSlice";
import { useState, useEffect, Fragment } from "react";

const Redirect = () => {
    const location = useLocation();
    const redirectLocation = location.pathname.split('/redirect/')[1]
    let credentials = JSON.parse(decodeURI(redirectLocation));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(setCredentials(credentials));
        navigate('/dashboard/miscontratos');
    },[credentials, redirectLocation, navigate, dispatch]);
    return 'redirect';
};

export default Redirect;